<template>
<div class="account-index">
  <div class="main-inner">

    <main>
      <ul>
        <li>
          <router-link to="/login">co-001 法人管理画面 – ログイン画面</router-link>
        </li>
        <li>
          <router-link to="/user">co-002 法人管理画面 – ユーザー管理 / co-003 法人管理画面 – ユーザー管理 – 新規ユーザー登録</router-link>
        </li>
        <li>
          <router-link to="/payment">co-007 法人管理画面 –お支払い情報 – 変更</router-link>
        </li>
        <li>
          <router-link to="/payment/payment-complete">co-009 法人管理画面 – お支払い情報 – 変更完了</router-link>
        </li>
      </ul>

    </main>

  </div>
</div>
</template>

<script>

export default {
  name: 'Index',
  data () {
    return {
      msg: 'Index'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/index.vue